import t from "@/lang/lang";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { MatchOneToOneTable } from "@/services/backend/business-central/components/match-one-to-one-table";
import { MatchType } from "../types/match-type";
import { MatchOneToOneCreateDialog } from "./match-one-to-one-create-dialog";

export function CompanyMatchesCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Unternehmen")}</CardTitle>
        <CardDescription>
          {t(
            "Hier werden die Unternehmen aus dem GSM mit den Unternehmen aus Business Central verknüpft.",
          )}
        </CardDescription>
        <CardAction>
          <MatchOneToOneCreateDialog type={MatchType.CompanyToCompany} />
        </CardAction>
      </CardHeader>
      <CardContent>
        <MatchOneToOneTable type={MatchType.CompanyToCompany} />
      </CardContent>
    </Card>
  );
}
